import React from 'react';
import FormInput from '../../../../library/form/components/FormInput';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormRichText from '../../../../library/form/components/FormRichText';
import FormWrapper from '../../../../library/form/components/FormWrapper';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import { compareNumber } from '../../../../helper/uiFunctions';

const BudgetHeaderLocationWiseRow = ({ formObject, viewData, rowKey }) => {
    const isEditing = compareNumber(viewData.dataList.isEditMode, 1);
    const location = formObject.getFormData(rowKey, '', 'location');
    const isUnassigned = !location.val || compareNumber(location.val, 0);

    const quantity = (paramName) => (
        <>
            {isEditing ? (
                <FormInput formObject={formObject} rowKey={rowKey} className="uiInput"
                    style={{ width: '98%', textAlign: 'right' }} action={{ InputType: 'input', paramName }} />
            ) : (
                <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName }} />
            )}
        </>
    );

    return (
        <ul className="uiDPEditLine">
            <li className="uiColumnLeft uiColumn100">
                <FormROValue formObject={formObject} rowKey={rowKey} format="#" action={{ paramName: 'docId' }} />
            </li>
            <li className="uiColumnLeft" style={{ width: '185px' }}>
                {isEditing ? (
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiAutoCompleteInput"
                        placeholder="None" action={{ InputType: 'ac', paramName: 'location', acMethod: 'Location' }} />
                ) : isUnassigned ? (
                    <SarasTrans value="None" />
                ) : (
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: 'location' }} />
                )}
            </li>
            <li className="uiColumnLeft uiColumn50">
                <div>
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: 'uom1' }} />
                </div>
                <FormWrapper formObject={formObject} rowKey={rowKey} customWrapper="div"
                    action={{ paramName: 'uom2' }}>
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: 'uom2' }} />
                </FormWrapper>
            </li>
            <li className="uiColumnRight uiColumnQty">
                <div>{quantity('value1')}</div>
                <FormWrapper formObject={formObject} rowKey={rowKey} customWrapper="div"
                    action={{ paramName: 'value2' }}>
                    {quantity('value2')}
                </FormWrapper>
            </li>
            <li className="uiColumnRight uiColumnQty">
                <div>
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: 'linkedValue1' }} />
                </div>
                <FormWrapper formObject={formObject} rowKey={rowKey} customWrapper="div"
                    action={{ paramName: 'linkedValue2' }}>
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: 'linkedValue2' }} />
                </FormWrapper>
            </li>
            <li className="uiColumnLeft" style={{ width: '220px' }}>
                {isEditing ? (
                    <FormRichText formObject={formObject} rowKey={rowKey} rows="3" cols="22"
                        className="uiFrmText" action={{ paramName: 'comment' }} />
                ) : (
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: 'comment' }} />
                )}
            </li>
            <li className="uiColumnCenter uiColumn100 uiActionBlock">
                {isEditing ? (
                    <>
                        <FormButton formObject={formObject} rowKey={rowKey} onlyIcon={true}
                            starIcon="confirm" tooltip="Confirm Changes" starIconClassName="uiColorNeutralAction"
                            action={{ attachHeaderRow: "sharedFields", actionId: 'save', actionParam: {}, containerKey: 'row' }} />
                        <FormButton formObject={formObject} rowKey={rowKey} onlyIcon={true}
                            starIcon="cancel" tooltip="Cancel Changes" starIconClassName="uiColorNegativeAction"
                            action={{ actionId: 'cancel', actionParam: {}, containerKey: 'row' }} />
                    </>
                ) : (
                    <>
                        <FormButton formObject={formObject} rowKey={rowKey} onlyIcon={true}
                            starIcon="edit" tooltip="Edit" starIconClassName="uiColorNeutralAction"
                            action={{ actionId: 'edit', actionParam: { editRow: "1" }, containerKey: 'row' }} />
                        {/* The server hides delBtn for the workspace root. */}
                        <FormButton formObject={formObject} rowKey={rowKey} onlyIcon={true}
                            starIcon="clear" tooltip="Delete" starIconClassName="uiColorNegativeAction"
                            action={{ actionId: 'del', paramName: 'delBtn', actionParam: {}, containerKey: 'row' }} />
                    </>
                )}
            </li>
        </ul>
    );
};

export default BudgetHeaderLocationWiseRow;
